interface Location {
  id: number;
  name: string;
}

export interface LocationsState {
  locations: Location[];
  selectedLocations: Location[];
  loading: boolean;
}

export enum LocationsActionTypes {
  GET_LOCATIONS = 'GET_LOCATIONS',
  SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS',
  SET_LOCATIONS_LOADING = 'SET_LOCATIONS_LOADING'
}

interface GetLocationsAction {
  type: LocationsActionTypes.GET_LOCATIONS;
  payload: Location[];
}

interface SetLocationsLoadingAction {
  type: LocationsActionTypes.SET_LOCATIONS_LOADING;
  payload: boolean;
}

interface SetSelectedLocationsAction {
  type: LocationsActionTypes.SET_SELECTED_LOCATIONS;
  payload: Location[];
}

export type LocationsAction =
  | GetLocationsAction
  | SetLocationsLoadingAction
  | SetSelectedLocationsAction;
